import _ from "lodash";
import React from "react";
import classes from "./AddEvidenceModalWrapper.scss";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import AddEvidenceModal from "AppComponents/AddEvidenceModal";
import ACLStore from "lib/aclStore";
import { ENABLE_AUTH_AND_EVAL_REVAMP } from "Constants/permissionConstants";
import AddEvidenceModalV2 from "AppComponents/AddEvidenceModalV2";
import { evidenceModalTemplate } from "./AddEvidenceModalWrapperTemplate";
import {
  styles,
  overlayComponentStyles,
} from "./AddEvidenceModalWrapperStyles";
import { getAddEvidenceModalTemplateMemoized } from "./AddEvidenceModalWrapperUtils";
import { openLinkInNewTab } from "modules/Services";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import update from "immutability-helper";
import {
  getPostDetailFromCache,
  getUnitPlanDetailsFromCache,
} from "IBPlanner/modules/IBGraphqlHelpers";
import { getUnitPlanFieldResponseFilter } from "UnitPlans/modules/Utils";
import { withRouter } from "react-router";
import { useI18n } from "Hooks";
import { getUnitPlanCentralRepoInputAndFilters } from "Courses/modules/utils";
import {
  getSelectedAcademicYearId,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";
import { getSelectedLearningCourseId } from "LearningCourse/modules/Utils";

const AddEvidenceModalWrapper = props => {
  const {
    currentAcademicYear,
    curriculumType,
    curriculumProgramId,
    onRequestClose,
    openLinkInNewTab,
    template,
    orgId,
    courses,
    unitPlanId,
    fieldId,
    onUpdateLocalResponseState,
    localResponsesObjectState,
    learningCourseId,
  } = props;

  const { t } = useI18n(["common"]);

  const responseObject = localResponsesObjectState[fieldId] || {};

  const [postEvidences, nonPostEvidences] = _.partition(
    _.get(responseObject, "evidence", []),
    evidence => _.has(evidence, "attachments")
  );

  const selectedPostIds = _.map(postEvidences, ({ id }) => id);

  const parentIdConfig = {
    REFLECTION_POST: orgId,
  };

  const onClickAddEvidence = params => {
    const selectedPostsIds = _.get(params, "evidences.REFLECTION_POST", []);

    const selectedPosts = _.map(selectedPostsIds, id => {
      return { ...getPostDetailFromCache(id), isPost: true };
    });

    onUpdateLocalResponseState({
      fieldId,
      updatedResponseObj: update(responseObject, {
        evidence: evidence =>
          update(evidence || [], {
            $set: [...selectedPosts, ...nonPostEvidences],
          }),
      }),
    });

    onRequestClose();
  };

  const onClickEvidenceView = ({ data }) => {
    openLinkInNewTab({
      url: `/platform/links/post/${data.id}?preserve_query_params=true`,
    });
  };

  const initialAppliedFilters = {
    REFLECTION_POST: {
      ACADEMIC_YEAR: currentAcademicYear ? [currentAcademicYear] : [],
      LEARNING_COURSE: learningCourseId ? [learningCourseId] : [],
      COURSE: courses,
      UNIT_PLAN: unitPlanId ? [unitPlanId] : [],
    },
  };

  const initiallySelectedEvidence = {
    REFLECTION_POST: selectedPostIds,
  };

  const addButtonLabel = _.isEmpty(selectedPostIds)
    ? t("common:add")
    : t("common:update");

  const isAuthAndEvalRevampEnabled = ACLStore.can(ENABLE_AUTH_AND_EVAL_REVAMP);

  return !_.isEmpty(initialAppliedFilters) ? (
    isAuthAndEvalRevampEnabled ? (
      <AddEvidenceModalV2
        template={template}
        curriculumProgramType={curriculumType}
        onClickCancel={onRequestClose}
        onClickAdd={onClickAddEvidence}
        onRequestClose={onRequestClose}
        modalContent={classes.addEvidenceModalCon}
        overlayContainer={classes.addEvidenceOverlayCon}
        parentIdConfig={parentIdConfig}
        onClickView={onClickEvidenceView}
        styles={styles}
        actionsStyles={overlayComponentStyles}
        curriculumProgramId={curriculumProgramId}
        initialAppliedFilters={initialAppliedFilters}
        initiallySelectedEvidence={initiallySelectedEvidence}
        addButtonLabel={addButtonLabel}
        modalHeight="772px"
        modalWidth="1080px"
      />
    ) : (
      <AddEvidenceModal
        template={template}
        curriculumProgramType={curriculumType}
        onClickCancel={onRequestClose}
        onClickAdd={onClickAddEvidence}
        onRequestClose={onRequestClose}
        modalContent={classes.addEvidenceModalCon}
        overlayContainer={classes.addEvidenceOverlayCon}
        parentIdConfig={parentIdConfig}
        onClickView={onClickEvidenceView}
        styles={styles}
        actionsStyles={overlayComponentStyles}
        curriculumProgramId={curriculumProgramId}
        initialAppliedFilters={initialAppliedFilters}
        initiallySelectedEvidence={initiallySelectedEvidence}
        addButtonLabel={addButtonLabel}
      />
    )
  ) : (
    <FullScreenLoader />
  );
};

const mapStateToProps = (state, ownProps) => {
  const orgId = _.get(state, "login.userInfo.org_id", "");
  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course",
    ""
  );
  const academicYearId = getSelectedAcademicYearId(state);
  const currentAcademicYear = _.get(
    getCurrentAcademicYear({ organizationId: orgId }),
    "id",
    ""
  );

  const curriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    "IB_PYP"
  );

  const curriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    null
  );

  const unitPlanId = _.get(ownProps, "params.unit_id", null);

  const template = getAddEvidenceModalTemplateMemoized({
    template: evidenceModalTemplate,
    curriculumProgramId,
  });

  const userInfo = _.get(state, "login.userInfo", {});

  const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
    organizationId: _.get(userInfo, "org_id", ""),
    courseId: selectedCourseId,
    academicYearId,
  });

  const responseFilter = getUnitPlanFieldResponseFilter();
  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  const unitPlanData = unitPlanId
    ? getUnitPlanDetailsFromCache({
        unitPlanId,
        centralRepoInput,
        responseFilter,
        collaboratorsFilter,
        exceptionalCollaboratorsFilter: collaboratorsFilter,
      })
    : {};

  const courseId = _.get(ownProps, "params.course_id", null);

  let courses = {};

  //When the modal is opened from within a course, Default course should be the course itself
  //And grade will be the grades to which course is mapped with
  if (courseId) {
    const courseDetails = _.find(
      _.get(unitPlanData, "courses", []),
      item => !item.isArchived && item.id == courseId
    );
    const grades = _.get(courseDetails, "grades", []);
    courses = _.map(grades, item => {
      return {
        key: item.id,
        values: [courseId],
      };
    });
  } else {
    //When the Modal is opened from Admin portal, i.e out of course then the default course filter will
    //be all the courses to which unit plan is mapped with
    courses = _.map(_.get(unitPlanData, "grades", []), id => {
      const courseIds = _.map(
        _.filter(_.get(unitPlanData, "courses", []), item => !item.isArchived),
        course => {
          if (_.some(course?.grades, { id })) {
            return course?.id;
          } else return;
        }
      );
      return {
        key: id,
        values: _.filter(courseIds, Boolean),
      };
    });
  }

  const learningCourseId = getSelectedLearningCourseId(state);

  return {
    currentAcademicYear,
    curriculumProgramId,
    curriculumType,
    orgId,
    isData: true,
    isLoading: false,
    template,
    courses,
    unitPlanId,
    learningCourseId,
  };
};

const mapActionCreators = { openLinkInNewTab };

export default compose(
  withRouter,
  connect(mapStateToProps, mapActionCreators)
)(AddEvidenceModalWrapper);
